<nb-card class="entity-edit-modal">
  <nb-card-header class="modal-header">
    <h5 class="modal-title center-title">{{ data.title }}</h5>
  </nb-card-header>

  <nb-card-body class="modal-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-fields">
        <div 
          *ngFor="let field of data.fields" 
          class="form-field"
          [class.form-field-error]="isFieldInvalid(field.key)"
        >
          <label class="form-label" [for]="field.key">
            {{ field.label }}
            <span *ngIf="field.required" class="required-indicator">*</span>
          </label>

          <!-- Text Input -->
          <input 
            *ngIf="field.type === 'text' || field.type === 'email'"
            nbInput
            fullWidth
            [id]="field.key"
            [type]="field.type"
            [formControlName]="field.key"
            [placeholder]="field.placeholder || ''"
            [status]="isFieldInvalid(field.key) ? 'danger' : 'basic'"
          />

          <!-- Number Input -->
          <input 
            *ngIf="field.type === 'number'"
            nbInput
            fullWidth
            type="number"
            [id]="field.key"
            [formControlName]="field.key"
            [placeholder]="field.placeholder || ''"
            [status]="isFieldInvalid(field.key) ? 'danger' : 'basic'"
          />

          <!-- Select Input -->
          <nb-select 
            *ngIf="field.type === 'select'"
            fullWidth
            [formControlName]="field.key"
            [placeholder]="field.placeholder || 'Select an option'"
            [status]="isFieldInvalid(field.key) ? 'danger' : 'basic'"
          >
            <nb-option 
              *ngFor="let option of field.options" 
              [value]="option.value"
            >
              {{ option.label }}
            </nb-option>
          </nb-select>

          <!-- Textarea -->
          <textarea 
            *ngIf="field.type === 'textarea'"
            nbInput
            fullWidth
            [id]="field.key"
            [formControlName]="field.key"
            [placeholder]="field.placeholder || ''"
            [status]="isFieldInvalid(field.key) ? 'danger' : 'basic'"
            rows="3"
          ></textarea>

          <!-- Error Message -->
          <div 
            *ngIf="isFieldInvalid(field.key)" 
            class="error-message"
          >
            {{ getFieldError(field.key) }}
          </div>
        </div>
      </div>
    </form>
  </nb-card-body>

  <nb-card-footer class="modal-footer">
    <div class="button-group">
      <button 
        nbButton 
        status="basic" 
        size="medium"
        type="button"
        (click)="onCancel()"
        [disabled]="isSubmitting"
      >
        {{ data.cancelButtonText || 'Cancel' }}
      </button>
      
      <button 
        nbButton 
        status="primary" 
        size="medium"
        type="button"
        (click)="onSubmit()"
        [disabled]="isSubmitting || form.invalid"
        [nbSpinner]="isSubmitting"
        nbSpinnerStatus="primary"
        nbSpinnerSize="small"
      >
        {{ data.submitButtonText || 'Save' }}
      </button>
    </div>
  </nb-card-footer>
</nb-card>
